import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { contractConstants } from '..';

export const useOnlineContractHasAccess = ({ contractId }: { contractId: number }) =>
  useQuery<boolean>({
    queryKey: [contractConstants.queryKeys.ONLINE_CONTRACT_HAS_ACCESS, contractId],
    queryFn: async () => {
      const res = await $api?.get(`/v1/online-contract/has-access/${contractId}`);

      return res?.data?.data;
    },
    enabled: !!contractId
  });
